import { useEffect } from 'react';
import { overlayGuard } from '@/contexts/PrivacyGuardContext/overlayguard';

export const useOverlayGuard = (isVisible: boolean) => {
  useEffect(() => {
    !!isVisible ? overlayGuard.enter() : overlayGuard.exit();
  }, [isVisible]);
};
